import { call } from "@saas/api-client";
import { Badge, Card, ConfirmAction, ErrorAlert, formatDate, Loading, PageHeader, Table, useAsync, useCommand } from "@saas/ui";
import { api } from "./api";

export function statusText(status: string, reason: string | null | undefined): string {
  if (status === "Active") return "Booked";
  return reason === "RoomDeactivated" ? "Cancelled (room removed)" : "Cancelled";
}

export function MyBookingsPage() {
  const bookings = useAsync(() => call(api.GET("/api/bookings/mine")), []);
  const command = useCommand();

  const cancel = async (id: string) => {
    if (await command.run(() => call(api.POST("/api/bookings/{id}/cancel", { params: { path: { id } } })))) bookings.reload();
  };

  return (
    <>
      <PageHeader title="My bookings" description="Your room bookings, latest first. Cancel the ones you no longer need so others can book the room." />
      <Card>
        <ErrorAlert error={command.error ?? bookings.error} />
        {bookings.loading && !bookings.data ? (
          <Loading />
        ) : bookings.data && bookings.data.length === 0 ? (
          <p className="sb-muted">You have no bookings yet.</p>
        ) : (
          <Table caption={`${bookings.data?.length ?? 0} booking(s)`} headers={["Room", "Starts", "Ends", "Status", ""]}>
            {bookings.data?.map((b) => (
              <tr key={b.id} data-testid={`booking-${b.id}`} data-room={b.roomName}>
                <td>{b.roomName}</td>
                <td>{formatDate(b.startsAt)}</td>
                <td>{formatDate(b.endsAt)}</td>
                <td>
                  <Badge tone={b.status === "Active" ? "success" : "neutral"}>{statusText(b.status, b.cancellationReason)}</Badge>
                </td>
                <td>
                  <div className="sb-actions">
                    {b.status === "Active" && new Date(b.endsAt) > new Date() && (
                      <ConfirmAction
                        label="Cancel booking"
                        confirmLabel="Yes, cancel it"
                        dismissLabel="Keep booking"
                        message={`Cancel your booking of ${b.roomName} on ${formatDate(b.startsAt)}?`}
                        pending={command.pending}
                        onConfirm={() => cancel(b.id)}
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </Table>
        )}
      </Card>
    </>
  );
}
